
import { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Pagination from '../pagination/Pagination';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

const Contact = () => {
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [contacts, setContacts] = useState([]);
  const [showPerPage, setShowPerPage] = useState(10);
  const [pagination, setPagination] = useState({ start: 0, end: showPerPage });

  const onChangePagination = (start, end) => {
    setPagination({ start, end });
  };

const getContacts = async () => {
  const dist = sessionStorage.getItem('dist');
  const res = await axios.get(`https://lionsdirectoryapi.emedha.in/contact/get?dist=${dist}`);
  setContacts(res.data);
};


const addContact = (e) => {
  e.preventDefault();
  const dist = sessionStorage.getItem('dist');

  axios.post(`https://lionsdirectoryapi.emedha.in/contact/post`, {
    mobile,
    email,
    address,
    dist
  })
  .then((response) => {
    alert(response.data.message);
    setShow(false);
    setMobile('');
    setEmail('');
    setAddress('');
    getContacts();
  });
};

  useEffect(() => {
    getContacts();
  }, []);

const deleteContact = (id) => {
    if (window.confirm('Are you sure you want to delete this contact?')) {
      axios.post(`https://lionsdirectoryapi.emedha.in/contact/delete`, { id })
        .then(() => {
          alert('Contact deleted successfully!');
          getContacts();
        });
    }
  };

  return (
    <>
      <Button variant="warning" onClick={handleShow}>
        Add Contact <PersonAddAltIcon />
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={addContact}>
            <label>Mobile</label>
            <input type="text" className="form-control" value={mobile} onChange={(e) => setMobile(e.target.value)} required />
            <br />
            <label>Email</label>
            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <br />
            <label>Address</label>
            <textarea className="form-control" value={address} onChange={(e) => setAddress(e.target.value)} required />
            <br />
            <button type="submit" className="btn btn-danger form-control">Submit</button>
          </form>
        </Modal.Body>
      </Modal>

      <div style={{ marginTop: '1rem' }} className="table-container">
        <table className="styled-table table table-bordered">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Address</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {contacts.slice(pagination.start, pagination.end).map((data, index) => (
              <tr key={data.id}>
                <td>{index + 1}</td>
                <td>{data.mobile}</td>
                <td>{data.email}</td>
                <td>{data.address}</td>
                <td>
                  <Link to="#" className="btn btn-danger" onClick={() => deleteContact(data.id)}>Delete</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* <Pagination page={showPerPage} onChangePagination={onChangePagination} total={contacts.length} /> */}
      </div>
    </>
  );
};

export default Contact;
